import { Flex, Text } from "@chakra-ui/react";

const TABS = ["Nhân viên", "Đơn thay đổi xăng xe", "Lịch sử thay đổi"];

export default function FuelTabsHeader({ tab, setTab, onRefresh, rightSlot }) {
  const onClickTab = (idx) => {
    if (idx === tab) {
      onRefresh?.();
      return;
    }
    setTab(idx);
  };

  return (
    <Flex alignItems="center" justifyContent="space-between" flexWrap="wrap" gap="12px">
      <Flex alignItems="center" gap={{ base: "74px" }}>
        <Text fontSize={{ base: "20px" }} fontWeight={600}>
          Quản lý xăng xe
        </Text>

        <Flex gap={{ base: "8px 24px" }} flexWrap={"wrap"}>
          {TABS.map((title, index) => (
            <Flex
              key={index}
              onClick={() => onClickTab(index)}
              cursor="pointer"
              padding="12px 5px 0px 5px"
              zIndex="10"
            >
              <Text
                position="relative"
                paddingBottom="8px"
                _before={{
                  content: '""',
                  position: "absolute",
                  bottom: "-1px",
                  left: 0,
                  width: "100%",
                  height: { base: tab === index ? "3px" : "0" },
                  backgroundColor: "var(--color-secondary)",
                }}
                fontSize={{ base: "16px" }}
                fontWeight={600}
                color={tab === index ? "var(--color-secondary)" : "#9D9D9D"}
                whiteSpace="nowrap"
              >
                {title}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex alignItems="center" gap="16px">
        {rightSlot}
      </Flex>
    </Flex>
  );
}
